// Cookie names — Firebase Hosting only forwards "__session" to Cloud Functions
export const SESSION_COOKIE_NAME = '__session';
export const SESSION_COOKIE_EXPIRES_IN_MS = 60 * 60 * 24 * 5 * 1000; // 5 days

/**
 * @TODO: load this from environment variable
 */
export const PROXY_URL = 'https://pattern-design-masterclass.bullet.site/';

export const LOGIN_URL = '/login/';

export const SESSION_API_ENDPOINT = '/api/session';
